export const MODAL_APPOINTMENT_CONFIRMATION = {
  TITLE: "Confirmación de cita",
  TEXT: "Su cita ha sido confirmada para "
};
